import network from '@/services/network';
import {
  ApiResponse,
  AssignableUser,
  ConsultationSlot,
  ConsultationSlotPayload,
} from '@/types';
import { ErrorResponse } from '@/utils';

const getConsultationSlots = async (): Promise<ApiResponse<ConsultationSlot[]>> => {
  try {
    const { data } = await network.get<ApiResponse<ConsultationSlot[]>>('/consultation-slots');
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const createConsultationSlot = async (
  payload: ConsultationSlotPayload,
): Promise<ApiResponse<ConsultationSlot>> => {
  try {
    const { data } = await network.post<ApiResponse<ConsultationSlot>>(
      '/consultation-slots',
      payload,
    );
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const updateConsultationSlot = async (
  id: number,
  payload: ConsultationSlotPayload,
): Promise<ApiResponse<ConsultationSlot>> => {
  try {
    const { data } = await network.put<ApiResponse<ConsultationSlot>>(
      `/consultation-slots/${id}`,
      payload,
    );
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const deleteConsultationSlot = async (id: number): Promise<void> => {
  try {
    await network.delete(`/consultation-slots/${id}`);
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

/**
 * Namensliste fuer das Ansprechpartner-Dropdown.
 *
 * Bewusst NICHT `/users`: die Leitung darf die Matrix pflegen, hat aber kein
 * `users.viewAny` (am 05.08.2026 auf dev gemessen). Dieser Endpoint liefert
 * genau `id` + `name` und haengt hinter derselben Bedingung wie das
 * Schreiben der Matrix.
 */
const getAssignableUsers = async (): Promise<ApiResponse<AssignableUser[]>> => {
  try {
    const { data } = await network.get<ApiResponse<AssignableUser[]>>(
      '/consultation-slots/assignable-users',
    );
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const consultationSlotApi = {
  getConsultationSlots,
  createConsultationSlot,
  updateConsultationSlot,
  deleteConsultationSlot,
  getAssignableUsers,
};

export default consultationSlotApi;
